import { createAsyncThunk } from '@reduxjs/toolkit'
import { getFeedbackTypes } from '../../api/support'

export const fetchFeedbackTypes = createAsyncThunk(
  'fetchFeedbackTypes',
  async (params, thunkAPI) => {
    const data = await getFeedbackTypes()
    // console.log(data)
    return data
  },
)
